import React, { Component } from 'react';
import { connect } from 'react-redux';
import ContractCheckGrid from "./ContractCheckGrid";
import moment from 'moment'
import Backdrop from '@material-ui/core/Backdrop';
import Alert from '@material-ui/lab/Alert';
import CircularProgress from '@material-ui/core/CircularProgress';
import ContractSearchForm from "./Search";
// import { customerList,  customerNewDispSet } from '../../Store/Customers';
import * as ContractCheck from './Saga/ContractCheck';
import { makeStyles, withStyles } from '@material-ui/core/styles';
interface Props {
    // customerNewDispSet: any,
    // customerNewDisp:number,
    // customerno:number,
    // customerList:any,
    // toggle:any,
    // get_rent_contract_accounting:any,
    get_rent_contracts_check_list: any,
    search_detail: any,
    classes: any,
    search_loading: boolean,
    user_details: any,
}



interface State {

    // state types
}


const styles = ((theme: any) => ({

    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}))



class CustomerList extends Component<Props, State> {
    componentWillMount() {
        this.props.get_rent_contracts_check_list()
        // this.props.get_rent_contracts()
        // this.props.customerNewDispSet(0)
        this.submit = this.submit.bind(this);
    }
    //     aa(state:any){
    // console.log(state)
    //     }

    submit(state: any) {
        console.log(state)

        this.props.get_rent_contracts_check_list(state)
    }

    csv() {

        // this.props.get_rent_contract_accounting(this.props.kyousais);
    }
    render() {

        return (
            <div className="row" >
                <div className="item-outer col-lg-12"
                //  style={{ display: (this.props.customerNewDisp === 0) ? '' : 'none' }}
                >
                    {/* {this.props.search_detail.contractor}   {this.props.search_detail.tatemono_name + this.props.search_detail.room_name}　 {moment(this.props.search_detail.start_at).format("YYYY/MM/DD")}～{moment(this.props.search_detail.end_at).format("YYYY/MM/DD")}
                    {this.props.search_detail.corse} */}
                    <div className="item">
                        {this.props.user_details.amSectionId == 40 || this.props.user_details.amSectionId == 10 || this.props.user_details.id == 1233 || this.props.user_details.id == 1101 ? <ContractSearchForm /> : ""}

                    </div>

                </div>

                {/* <div className="item-outer col-lg-12" style={{ display: (this.props.customerNewDisp === 1) ? '' : 'none' }}>
                    <div className="item">
           
                    </div>
                </div> */}


                <div className="item-outer col-lg-12"
                // style={{ display: (this.props.customerNewDisp === 0) ? '' : 'none' }}
                >
                    <div className="item">
                        {this.props.user_details.amSectionId == 40 || this.props.user_details.amSectionId == 10 ? <ContractCheckGrid /> : <Alert severity="error">JS課専用</Alert>}

                    </div>
                </div>
                <Backdrop className={this.props.classes.backdrop} open={this.props.search_loading} >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        );
    }
};


//export  default CustomerList;
const mapStateToProps = (state: any) => {
    return {
        // customerNewDisp: state.customersReducer.customerNewDisp,
        // rent_contracts_list: state.rentContractsReducer.rent_contracts_list,
        search_loading: state.ContractCheck.search_loading,
        user_details: state.masterReducer.user_details,
    }
}
function mapDispatchToProps(dispatch: any) {
    return {
        // customerList(search:any) {
        //     dispatch(customerList(search))
        // },
        // customerNewDispSet(state:number) {
        //     dispatch(customerNewDispSet(state))
        // },
        // get_rent_contract_accounting(state:any) {
        //     dispatch(Monies.get_rent_contract_accounting(state))
        // },
        get_rent_contracts_check_list(state: any) {
            dispatch(ContractCheck.get_rent_contracts_check_list(state))
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CustomerList));




